import * as types from "./types";

export const updateCollectionsList = (payload) => (dispatch) =>
    dispatch({ type: types.UPDATE_COLLECTIONS_LIST, payload });

export const setCollectionsList = (payload) => (dispatch) =>
    dispatch({ type: types.SET_COLLECTIONS_LIST, payload });
